export default __webpack_public_path__ + "7c7bb8091a5eeb52b21ceaa57758513b.gif";